import { upsertPurchaseOrderSupplierDiscount } from 'src/features/ReceiptingSlice'

/**
 * Convert whole-order discount pounds (from AddInvoiceModal) to pennies.
 * Returns 0 when missing / invalid so callers can skip the save.
 */
export function wholeOrderDiscountToPennies(amountPounds) {
  const amount = Number(amountPounds)
  if (!Number.isFinite(amount) || amount <= 0) return 0
  return Math.round(amount * 100)
}

/**
 * After a manual order is created, persist the AI/UI whole-order discount as a
 * PurchaseOrderAdjustment so Goods Receipting / reconcile see the same total.
 * Failures are reported by upsertPurchaseOrderSupplierDiscount; order create
 * still succeeds.
 */
export async function persistManualOrderWholeOrderDiscount({
  dispatch,
  venueId,
  purchaseOrderNumber,
  discountPounds,
}) {
  const discountPennies = wholeOrderDiscountToPennies(discountPounds)
  const po = String(purchaseOrderNumber || '').trim()
  const venue = String(venueId || '').trim()
  if (!discountPennies || !po || !venue || typeof dispatch !== 'function') {
    return true
  }

  return dispatch(
    upsertPurchaseOrderSupplierDiscount({
      venueId: venue,
      purchaseOrderNumber: po,
      discountPennies,
      note: 'Whole-order discount from manual order',
      rematch: false,
    }),
  )
}
